import { Share } from 'react-native';

export default class ShareMessage {
    static run = (message) => {
        Share.share({ message }).catch((e) => console.log(e))
    };
}
